import { AbstractDimension } from '@orus.eu/dimensions'
import { type NlAovqlQuoteV3, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'

import { nlAovqlClientInputLocking } from './nl-aovql-client-input-locking.ts'

export class NlAovqlQuoteDimension<NAME extends string> extends AbstractDimension<NAME, NlAovqlQuoteV3> {
  override formatToString(value: NlAovqlQuoteV3): string {
    return quoteV3ToSerializedQuoteData(value)
  }
}

export const nlAovqlQuoteDimension = new NlAovqlQuoteDimension({
  name: 'nlAovqlQuote',
  displayKeys: { name: 'dimension_name_nl_aovql_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: nlAovqlClientInputLocking,
} as const)
